import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/vi';
import 'dayjs/locale/en';
import i18n from '../../languages/i18n';

dayjs.extend(customParseFormat);


const formatDateTime = (dateString, formatKey = 'dateFormat.dateTime') => {
  if (!dateString) return '';
  return dayjs(dateString).locale(i18n.language).format(i18n.t(formatKey));
};

export const isDate = (str) => {
  if (typeof str !== 'string') return false;
  const s = str.trim();
  const formats = ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY', 'D-M-YYYY', 'D/M/YYYY'];
  return dayjs(s, formats, true).isValid();
};

export const isTime = (str) => {
  if (typeof str !== 'string') return false;
  const s = str.trim();
  const formats = ['HH:mm', 'HH:mm:ss', 'H:mm', 'H:mm:ss'];
  return dayjs(s, formats, true).isValid();
};



export default formatDateTime;

